import { cn as packageCn, en as packageEn, jp as packageJp, tw as packageTw } from '@eureka/utils/package-locale';

export const cn = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        more: '查看全部 →',
        creditsTip: '可用于 AI 功能的积分余额',
        ...packageCn,
    },
}

export const en = {
    PtUserBanner: {
        endTime: 'Expiration Date: {date}',
        more: 'More →',
        creditsTip: 'Available credits for AI features',
        ...packageEn,
    },
}

export const jp = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        more: '続き →',
        creditsTip: 'AI機能に使用可能なクレジット残高',
        ...packageJp,
    },
}

export const tw = {
    PtUserBanner: {
        endTime: '到期日期：{date}',
        more: '檢視全部 →',
        creditsTip: '可用於 AI 功能的積分餘額',
        ...packageTw,
    },
}
